import { render, staticRenderFns } from "./HandleArticleResource.vue?vue&type=template&id=10b591ab"
import script from "./HandleArticleResource.vue?vue&type=script&lang=js"
export * from "./HandleArticleResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports